import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import {
  createSortableHeader,
  DataTable,
} from "../../../../../components/ui/data-table";
import { AntecipationRecord } from "../types";

interface AntecipationTableProps {
  data: AntecipationRecord[];
  isLoading: boolean;
  exportFileName?: string;
}

export function AntecipationTable({
  data,
  isLoading,
  exportFileName = "solicitacoes-antecipacao",
}: AntecipationTableProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    return dateString.substring(0, 10);
  };

  const columns = useMemo<ColumnDef<AntecipationRecord>[]>(
    () => [
      {
        accessorKey: "dataRomaneio",
        header: createSortableHeader("Data Romaneio"),
        cell: ({ row }) => formatDate(row.getValue("dataRomaneio")),
      },
      {
        accessorKey: "valorCompra",
        header: createSortableHeader("Valor Compra"),
        cell: ({ row }) => (
          <span className="font-semibold">
            {formatCurrency(row.getValue("valorCompra"))}
          </span>
        ),
      },
      {
        accessorKey: "valorFace",
        header: createSortableHeader("Valor Face"),
        cell: ({ row }) => (
          <span className="font-semibold">
            {formatCurrency(row.getValue("valorFace"))}
          </span>
        ),
      },
      {
        accessorKey: "cnpjCpf",
        header: createSortableHeader("CNPJ/CPF"),
      },
      {
        accessorKey: "ops",
        header: createSortableHeader("Operadora"),
      },
      {
        accessorKey: "comprovanteBancario",
        header: "Comprovante",
        cell: ({ row }) => {
          const comprovante = row.getValue("comprovanteBancario") as
            | string
            | undefined;
          if (comprovante) {
            return (
              <a
                href={comprovante}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:text-primary/80"
              >
                Ver comprovante
              </a>
            );
          }
          return <span className="text-muted-foreground">N/A</span>;
        },
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      title={`Solicitações de Antecipação (${data.length} registros)`}
      loading={isLoading}
      searchPlaceholder="Pesquise por CNPJ/CPF, operador..."
      exportFileName={exportFileName}
      enableExport={true}
      pageSize={15}
    />
  );
}
